import { loanResponseStatus } from '@repo/shared/types';
var internalError = {
    type: 'LOAN',
    data: {
        errorDescription: 'Internal server error',
    },
};
// 422 with full availableRevenueRate (same shape as discount/validate 200)
var discountSoftErrorLoanAmountTooHigh = {
    requestId: 'MSWMOCK-l0an-add-s0ft-err-am0unt-h1gh001',
    timestamp: '2024-04-26 13:36:49',
    type: 'DISCOUNT_VALIDATE',
    data: {
        discountEnabled: false,
        reasonCode: 'LOAN_AMOUNT_TO_HIGH',
        reason: 'The loan amount exceeds the maximum allowed for this promotion code',
        limitId: 11131,
        preLimitId: null,
        availableRevenueRate: {
            original: {
                period: 4,
                pricing: 9.9,
                loanRepaymentPrice: 29.91,
                amountMax: 17200,
                amountMin: 3000,
            },
            discounted: {
                period: 4,
                pricing: 7.0,
                loanRepaymentPrice: 25.0,
                amountMax: 10000,
                amountMin: 3000,
            },
        },
    },
};
// 422 with LOAN type (real API shape — type: LOAN, no discountEnabled)
var discountSoftErrorLoanAmountTooLow = {
    requestId: '88540f7e-b6a9-43c1-b481-0384fa713233',
    timestamp: '2026-05-08 09:21:41',
    type: 'LOAN',
    data: {
        parameter: 'loan.code',
        reasonCode: 'LOAN_AMOUNT_TO_LOW',
        reason: 'Super! Z tym kodem możesz skorzystać z promocji od kwoty 40000 zł. Automatycznie ustawiliśmy minimalną kwotę wniosku.',
        availableRevenueRate: {
            original: {
                period: 12,
                pricing: 18.5,
                loanRepaymentPrice: 15,
                amountMax: 50000,
                amountMin: 3000,
            },
            discounted: {
                period: 12,
                pricing: 18,
                loanRepaymentPrice: 29.93,
                amountMax: 33400,
                amountMin: 3000,
            },
        },
    },
};
// 422 with simple schema (no availableRevenueRate)
var discountSimpleErrorUsed = {
    requestId: 'MSWMOCK-l0an-add-s1mpl-err-us3d001',
    timestamp: '2026-05-08 09:21:41',
    type: 'LOAN',
    data: {
        parameter: 'loan.code',
        reasonCode: 'USED',
        reason: 'The promotion code has already been used',
    },
};
var discountSimpleErrorCodeExpired = {
    requestId: 'MSWMOCK-l0an-add-s1mpl-err-exp1red01',
    timestamp: '2026-05-08 09:21:41',
    type: 'LOAN',
    data: {
        parameter: 'loan.code',
        reasonCode: 'CODE_EXPIRED',
        reason: 'The promotion code has expired',
    },
};
var successNew = {
    requestId: 'MSWMOCK-a2355033-bc0f-4dc8-a16f-a856f26f9ccd',
    timestamp: '2024-04-25 12:48:59',
    type: 'LOAN',
    data: {
        loanId: 1234523,
        status: loanResponseStatus.enum.NEW,
        providerRequest: 'requested',
        stage: 1,
    },
};
var successRejected = {
    requestId: 'MSWMOCK-a2355033-bc0f-4dc8-a16f-a856f26f9ccd',
    timestamp: '2024-04-25 12:48:59',
    type: 'LOAN',
    data: {
        loanId: 1234523,
        status: loanResponseStatus.enum.REJECTED,
        providerRequest: 'requested',
        stage: 1,
    },
};
export var loanAddMock = {
    successNew: successNew,
    successRejected: successRejected,
    internalError: internalError,
    discountSoftErrorLoanAmountTooHigh: discountSoftErrorLoanAmountTooHigh,
    discountSoftErrorLoanAmountTooLow: discountSoftErrorLoanAmountTooLow,
    discountSimpleErrorUsed: discountSimpleErrorUsed,
    discountSimpleErrorCodeExpired: discountSimpleErrorCodeExpired,
};
